const t = (key, fallback = '') => (window.SPRAGA_I18N && SPRAGA_I18N[key]) || fallback || key;

jQuery(document).ready(function ($) {
    $('#subscribe-form').on('submit', function (e) {
        e.preventDefault();

        var form = $(this);
        var button = form.find('button[type="submit"]');
        var originalText = button.html();
        var messageBox = form.find('.form-message');

        // If message container doesn't exist, create it dynamically
        if (messageBox.length === 0) {
            form.append('<div class="form-message"></div>');
            messageBox = form.find('.form-message');
        }

        // Clear previous messages and styles
        messageBox.html('').removeClass('error success');
        form.find('input').removeClass('input-error');

        // Get email for client-side validation
        var email = form.find('input[name="email"]').val();

        // Basic client-side validation
        if (!email) {
            messageBox.html(t("enter_your_email", "Please enter your email.")).addClass('error');
            form.find('input[name="email"]').addClass('input-error');
            return;
        }

        // Disable button and show processing state
        button.prop('disabled', true).html(t("processing", "Processing..."));

        // Collect data (automatically grabs email, b_check, and other fields)
        var formData = form.serialize();

        // Add required parameters for WP AJAX
        formData += '&action=create_coupon';
        formData += '&nonce=' + spraga_obj.nonce;

        $.ajax({
            url: spraga_obj.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: formData,
            success: function (response) {

                if (response.success) {
                    // Success! Show popup
                    if (messageBox.is(':hidden')) {
                        messageBox.slideDown(500);
                    }
                    messageBox.html(t("subscribed", "Subscribed!")).addClass('success'); // Keeping simple text in input too

                    // Open Magnific Popup
                    $.loadMagnificPopup().then(function () {
                        $.magnificPopup.open({
                            items: {
                                src: '#subscribe-success-popup',
                                type: 'inline'
                            },
                            mainClass: 'mfp-fade',
                            removalDelay: 160,
                            preloader: false,
                            fixedContentPos: false
                        });
                    })

                    // Reset form
                    form[0].reset();
                    button.prop('disabled', false).html(originalText);

                    setTimeout(function () {
                        messageBox.slideUp(500);
                    }, 5000)

                } else {
                    // Server error (e.g., email taken or bot detected)
                    if (messageBox.is(':hidden')) {
                        messageBox.slideDown(500);
                    }
                    messageBox.html(response.data.error || t("something_went_wrong_try_again", "Something went wrong. Please try again.")).addClass('error');
                    button.prop('disabled', false).html(originalText);
                    setTimeout(function () {
                        messageBox.slideUp(500);
                    }, 5000)
                }
            },
            error: function (xhr, status, error) {
                console.log(xhr.responseText);
                messageBox.html(t("server_error", "Server error. Please try again later.")).addClass('error');
                button.prop('disabled', false).html(originalText);
            }
        });
    });
});